import { __decorate } from "tslib";
import { Component, Vue, Prop } from "vue-property-decorator";
import i18n from "@/config/i18n";
let PiHomeMmapScreenScale = class PiHomeMmapScreenScale extends Vue {
    constructor() {
        super(...arguments);
        this.poptipVisible = false;
        this.all = false;
        this.staSizeList = [
            { itemKey: "1", itemValue: i18n.t("homeMap.smallSize") },
            { itemKey: "2", itemValue: i18n.t("homeMap.mediumSize") },
            { itemKey: "3", itemValue: i18n.t("homeMap.largeSize") },
        ];
        this.nameText = "";
        this.formInline = {
            staSizeList: [],
        };
    }
    /**
     * 重置
     */
    resetting() {
        this.formInline.staSizeList = [];
        this.nameText = "";
    }
    /**
     * 全选
     */
    cllChange(val) {
        if (!val) {
            this.resetting();
        }
        else {
            this.formInline.staSizeList = this.staSizeList.map((item) => {
                return item.itemKey;
            });
        }
    }
    /**
     * 返回数据
     */
    retureData() {
        this.poptipVisible = false;
        this.nameText = this.forCityName(this.staSizeList, this.formInline.staSizeList);
        this.$emit("change", {
            ...this.formInline,
        });
    }
    /**
     * 找出名称
     */
    forCityName(list, itemKey) {
        let name = [];
        list.map((item) => {
            if (itemKey.indexOf(item.itemKey) != -1) {
                name.push(item.itemValue);
            }
        });
        return name.join("/");
    }
};
__decorate([
    Prop({ default: "" })
], PiHomeMmapScreenScale.prototype, "searchName", void 0);
PiHomeMmapScreenScale = __decorate([
    Component({
        components: {},
    })
], PiHomeMmapScreenScale);
export default PiHomeMmapScreenScale;
